import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { useBellUnreadCount } from '../api/notifications-queries'
import {
  formatUnreadBadgeDisplay,
  notificationsBellAriaLabel,
} from '../lib/format-unread-badge'
import { resolveNotificationNavigatePath } from '../lib/resolve-notification-path'
import {
  notificationBellBadgeSx,
  notificationBellBadgeTextSx,
  notificationBellButtonSx,
  notificationBellIconWrapSx,
} from '../styles/notificationBellStyles'
import { NotificationBellGlyph } from './NotificationBellGlyph'
import { NotificationPanel } from './NotificationPanel'

export function NotificationBell() {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const { data: unreadCount = 0 } = useBellUnreadCount()

  const open = Boolean(anchorEl)
  const badgeDisplay = formatUnreadBadgeDisplay(unreadCount)

  function handleOpen(e: React.MouseEvent<HTMLElement>) {
    if (open) {
      setAnchorEl(null)
      return
    }
    setAnchorEl(e.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        onClick={handleOpen}
        aria-label={notificationsBellAriaLabel(unreadCount)}
        aria-haspopup="true"
        aria-expanded={open}
        data-testid="provider-nav-notifications"
        sx={notificationBellButtonSx}
      >
        <Box sx={notificationBellIconWrapSx}>
          <NotificationBellGlyph sx={{ fontSize: 24 }} />
          {unreadCount > 0 ? (
            <Box component="span" sx={notificationBellBadgeSx} data-testid="provider-nav-notifications-badge">
              <Box component="span" sx={notificationBellBadgeTextSx(badgeDisplay)}>
                {badgeDisplay}
              </Box>
            </Box>
          ) : null}
        </Box>
      </IconButton>

      <NotificationPanel
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onViewAll={() => {
          handleClose()
          navigate('/notifications')
        }}
        onNavigate={(url) => navigate(resolveNotificationNavigatePath(url))}
      />
    </>
  )
}
